module.exports = __webpack_public_path__ + "img/ycpb.8ffebb3f.png";